import styled from 'styled-components';
import dayjs from 'dayjs';
import { P, fs, radius } from '../theme/tokens';
import { tagColor } from '../utils/tags';
import StatusPill from './StatusPill';
import { Block, Muted } from './Modal/styled';

const Items = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const Item = styled.li`
  padding: 12px;
  border: 1px solid ${P.line};
  border-radius: ${radius.lg}px;

  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  time {
    font-size: 11px;
    color: ${P.subtle};
  }
  p {
    margin: 8px 0 0;
    font-size: ${fs.sm}px;
    color: ${P.muted};
  }
`;

export default function HistoryList({ items = [], title = 'Communication history', emptyText }) {
  return (
    <Block>
      <h3>{title}</h3>
      {items.length ? (
        <Items>
          {items.map((h) => (
            <Item key={`${h.kind}-${h.at}-${h.label}`}>
              <div>
                <StatusPill color={tagColor(h.label)}>{h.label}</StatusPill>
                <time dateTime={h.at}>{dayjs(h.at).format('MMM D, h:mm A')}</time>
              </div>
              <p>{h.text}</p>
            </Item>
          ))}
        </Items>
      ) : (
        <Muted>{emptyText}</Muted>
      )}
    </Block>
  );
}
